import propTypes from 'prop-types'
import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
// import Image from '../../assets/rooms/rooms-modal.webp'
import WhatsAppButton from '../WhatsAppButton'

const RoomsAlertModal = ({ closeModal }) => {
  useEffect(() => {
    const htmlElement = document.documentElement
    htmlElement.style.overflow = 'hidden'

    return () => {
      htmlElement.style.overflow = 'unset'
    }
  }, [])

  return (
    <div className="RoomsAlertModal PanelModal px-3" onClick={closeModal}>
      <div className="PanelModal__Card--Big" onClick={(e) => e.stopPropagation()}>
        <header>
          <button className="PanelModal__Button-Close" onClick={closeModal}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>

        <div className='d-flex flex-column flex-md-row gap-4 align-items-center align-items-md-start text-center text-md-start' style={{ padding: '25px', paddingTop: '40px'}}>
          {/* <img src={Image} height={200} alt="Reuniones Alerta" title="Reuniones Alerta" /> */}
          <div className='d-flex flex-column gap-3'>
            <span className='text-green title-2'>Sabías que...</span>
            <span className='text-1 fw-medium'>Podes hacer tu workshop, jornada laboral, reunión operativa, por horas.</span>
            <WhatsAppButton
              label="Reservar ahora"
              message="Hola, quiero reservar una sala de reuniones"
              contact='5493513525163'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

RoomsAlertModal.propTypes = {
  closeModal: propTypes.func.isRequired
}

export default RoomsAlertModal
